import { 
	EDIT_REQUEST,
	EDIT_REQUEST_ERROR,
	EDIT_REQUEST_SUCCESS,
	GET_REQUEST_TRANSLATION, 
	GET_REQUEST_TRANSLATION_ERROR, 
	GET_REQUEST_TRANSLATION_SUCCESS,
	GET_FACULTIES,
	GET_FACULTIES_ERROR,
	GET_FACULTIES_SUCCESS,
	GET_LANGUAGES,
	GET_LANGUAGES_ERROR,
	GET_LANGUAGES_SUCCESS,
	GET_PAYMENT_METHODS,
	GET_PAYMENT_METHODS_ERROR,
	GET_PAYMENT_METHODS_SUCCESS,
	GET_PROVIDERS,
	GET_PROVIDERS_ERROR,
	GET_PROVIDERS_SUCCESS,
	GET_CUSTOMERS,
	GET_CUSTOMERS_SUCCESS,
	GET_CUSTOMERS_ERROR,
	GET_ROLES,
	GET_ROLES_SUCCESS,
	GET_ROLES_ERROR,
	DELETE_USER,
	DELETE_USER_SUCCESS,
	DELETE_USER_ERROR,
	ADD_CUSTOMER,
	ADD_CUSTOMER_SUCCESS,
	ADD_CUSTOMER_ERROR,
	EDIT_CUSTOMER,
	EDIT_CUSTOMER_SUCCESS,
	EDIT_CUSTOMER_ERROR,
	ADD_PROVIDER,
	ADD_PROVIDER_SUCCESS,
	ADD_PROVIDER_ERROR,
	EDIT_PROVIDER,
	EDIT_PROVIDER_SUCCESS,
	EDIT_PROVIDER_ERROR
} from 'redux/constants/Request';

const initState = {
	loading: false,
	specialities: [],
	faculties: [],
	universities: [],
	languages: [],
	paymentMethods: [],
	providers: [],
	customers: [],
	roles: [],
	message: '',
	
	data: [],
	page: 1,
	size: 10,
	total: 0,
	totalPages: 1,
	paymentState: 'all',
	service: 'all'
}

const request = (state = initState, action) => {
	switch (action.type) {
		case GET_REQUEST_TRANSLATION:
			return {
				...state,
				loading: true,
				total: 0,
				data: [],
				page: action.payload.query.page,
				size: action.payload.query.size,
				paymentState: action.payload.query.paymentState,
				service: action.payload.query.service
			}
		case GET_REQUEST_TRANSLATION_SUCCESS:
			return {
				...state,
				loading: false,
				total: action.data.total,
				data: action.data.data,
				totalPages: action.data.totalPages
			}
		case GET_REQUEST_TRANSLATION_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_FACULTIES:
			return {
				...state,
				loading: true,
				specialities: [],
				faculties: [],
				universities: []
			}
		case GET_FACULTIES_SUCCESS:
			return {
				...state,
				loading: false,
				specialities: action.specialities,
				faculties: action.faculties,
				universities: action.universities
			}
		case GET_FACULTIES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_LANGUAGES:
			return {
				...state,
				loading: true,
				languages: []
			}
		case GET_LANGUAGES_SUCCESS:
			return {
				...state,
				loading: false,
				languages: action.languages
			}
		case GET_LANGUAGES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_PAYMENT_METHODS:
			return {
				...state,
				loading: true,
				paymentMethods: []
			}
		case GET_PAYMENT_METHODS_SUCCESS:
			return {
				...state,
				loading: false,
				paymentMethods: action.paymentMethods
			}
		case GET_PAYMENT_METHODS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_PROVIDERS:
			return {
				...state,
				loading: true,
				providers: []
			}
		case GET_PROVIDERS_SUCCESS:
			return {
				...state,
				loading: false,
				providers: action.providers
			}
		case GET_PROVIDERS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_CUSTOMERS:
			return {
				...state,
				loading: true,
				customers: []
			}
		case GET_CUSTOMERS_SUCCESS:
			return {
				...state,
				loading: false,
				customers: action.customers
			}
		case GET_CUSTOMERS_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_ROLES:
			return {
				...state,
				loading: true,
				roles: []
			}
		case GET_ROLES_SUCCESS:
			return {
				...state,
				loading: false,
				roles: action.roles
			}
		case GET_ROLES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_REQUEST:
			return {
				...state,
				loading: true,
			}
		case EDIT_REQUEST_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_REQUEST_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case DELETE_USER:
			return {
				...state,
				loading: true,
			}
		case DELETE_USER_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DELETE_USER_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_CUSTOMER:
			return {
				...state,
				loading: true,
			}
		case ADD_CUSTOMER_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_CUSTOMER_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_CUSTOMER:
			return {
				...state,
				loading: true,
			}
		case EDIT_CUSTOMER_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_CUSTOMER_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_PROVIDER:
			return {
				...state,
				loading: true,
			}
		case ADD_PROVIDER_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_PROVIDER_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_PROVIDER:
			return {
				...state,
				loading: true,
			}
		case EDIT_PROVIDER_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_PROVIDER_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		default:
			return state;
	}
}

export default request